import React__default from 'react';

var YouMayAlsoLikeHeader = function YouMayAlsoLikeHeader(props) {
  var header = props.header;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mb-[7px]"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "font-sans text-p-18 font-bold leading-[36px]",
    "automation-id": "YouMayAlsoLikeHeader"
  }, header));
};

export { YouMayAlsoLikeHeader };
//# sourceMappingURL=you-may-also-like-header.esm.js.map
